import React from 'react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import Content, { HeaderLink } from '../../components/Content';
import UserCard from './UserCard';
import NoData from '../../components/NoData';
import SearchBox from '../ChatScreenNew/User/SearchBox';
import EmailContent from './EmailContent';
import DeleteMailModal from './DeleteMailModal';
import ComposeMailModal from './ComposeMailModal';

import EmailClientStyles from './EmailClient.module.css';

const EmailClient = () => {
	const { t } = useTranslation();
	const data = [
		{
			_id: 1,
			name: 'John Doe',
			email: {
				subject: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa',
				time: '2022-08-19T13:59:08.645Z',
				isRead: false,
				body: `Hello John,\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.\nEt dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`
			},
			hasAttachment: true,
			attachments: [
				{ fileName: 'Duis aute irure dolor irure.pdf' },
				{ fileName: 'Officia deserunt mollit anim.jpg' },
				{ fileName: 'Duis aute irure dolor.jpg' }
			],
			isFavorite: false
		},
		{
			_id: 2,
			name: 'Martina',
			email: {
				subject: 'Lorem ipsum dolor sit amet consectetur adipisicing elit',
				time: '2022-08-18T15:59:08.645Z',
				isRead: true,
				body: `Hello John,\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.\nEt dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`
			},
			hasAttachment: false,
			isFavorite: true
		},
		{
			_id: 3,
			name: 'Robert Jack',
			email: {
				subject: 'Lorem ipsum dolor sit amet consectetur',
				time: '2022-08-18T14:59:08.645Z',
				isRead: false,
				body: `Hello John,\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.\nEt dolore magna aliqua. Ut ullamco laboris nisi ut aliquip ex ea commodo consequat.`
			},
			hasAttachment: true,
			attachments: [
				{ fileName: 'Duis aute irure dolor irure.pdf' },
				{ fileName: 'Officia deserunt mollit anim.jpg' },
				{ fileName: 'Duis aute irure dolor.jpg' }
			],
			isFavorite: true
		},
		{
			_id: 4,
			name: 'Daniel Right',
			email: {
				subject: 'Lorem ipsum dolor sit amet consectetur adipisicing elit',
				time: '2022-08-17T01:59:08.645Z',
				isRead: true,
				body: `Hello John,\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.\nEt dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.\nEt dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`
			},
			hasAttachment: false,
			isFavorite: false
		},
		{
			_id: 5,
			name: 'Mark Henry',
			email: {
				subject: 'Lorem ipsum dolor sit',
				time: '2022-08-16T13:59:08.645Z',
				isRead: true,
				body: `Hello John,\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.\nEt dolore magna aliqua. Ut ullamco laboris nisi ut aliquip ex ea commodo consequat.`
			},
			hasAttachment: false,
			isFavorite: false
		}
	];

	const emailEndRef = React.useRef(null);
	const [ searchKey, setSearchKey ] = React.useState('');

	const [ selectedUser, setSelectedUser ] = React.useState({});
	const [ deleteMailModal, setdeleteMailModal ] = React.useState({ data: {}, status: false });
	const [ sendReply, setSendReply ] = React.useState(false);

	const [ composeMailModal, setComposeMailModal ] = React.useState(false);
	const [ emails, setEmails ] = React.useState([]);

	const scrollToEnd = () => {
		emailEndRef && emailEndRef.current && emailEndRef.current.scrollIntoView({ behavior: 'smooth' });
	};

	React.useEffect(
		() => {
			if (sendReply) scrollToEnd();
		},
		[ sendReply ]
	);

	const handleNextEmail = (currentId) => {
		const index = data
			.filter((user) => user.name.toLowerCase().includes(searchKey.toLowerCase()))
			.map((object) => object._id)
			.indexOf(currentId);
		if (index + 1 < data.length) setSelectedUser(data[index + 1]);
	};

	const handlePrevEmail = (currentId) => {
		const index = data
			.filter((user) => user.name.toLowerCase().includes(searchKey.toLowerCase()))
			.map((object) => object._id)
			.indexOf(currentId);
		if (index + 1 > 1) setSelectedUser(data[index - 1]);
	};

	return (
		<Content
			currentMenu='email'
			customHeader={true}
			customHeaderComponent={
				<Fragment>
					<HeaderLink label={t('screens.email.client.inbox')} type='button' active />
					<HeaderLink label={t('screens.email.client.starred')} type='button' />
					<HeaderLink label={t('screens.email.client.sent')} type='button' />
					<HeaderLink label={t('screens.email.client.draft')} type='button' />
					<HeaderLink label={t('screens.email.client.composeEmail')} type='button' isSpecial onClick={() => setComposeMailModal(true)} />
				</Fragment>
			}>
			<div className={EmailClientStyles.content}>
				<div className={EmailClientStyles.mailUsers}>
					<SearchBox placeholder={t('screens.email.client.searchInbox')} value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />

					<div className={EmailClientStyles.filterUsers}>
						<div className={EmailClientStyles.filterUser}>
							<input type='checkbox' name='select' className={EmailClientStyles.filterUser_checkbox} />
							<button className={EmailClientStyles.filterUser_btn}>
								<svg>
									<use xlinkHref={`/assets/sprite.svg#icon-chevron-down`} />
								</svg>
							</button>
						</div>

						<div className={EmailClientStyles.filterUser}>
							<p className={EmailClientStyles.filterUser_text}>{t('screens.email.client.today')}</p>
							<button className={EmailClientStyles.filterUser_btn}>
								<svg>
									<use xlinkHref={`/assets/sprite.svg#icon-filter`} />
								</svg>
							</button>
						</div>
					</div>

					{data.filter((user) => user.name.toLowerCase().includes(searchKey.toLowerCase())).length === 0 ? (
						<NoData title={t('screens.email.client.noResults')} />
					) : (
						data
							.filter((user) => user.name.toLowerCase().includes(searchKey.toLowerCase()))
							.map((d) => (
								<UserCard
									key={d._id}
									user={d}
									active={selectedUser && selectedUser._id === d._id}
									onClick={() => setSelectedUser(d)}
								/>
							))
					)}
				</div>

				<div className={EmailClientStyles.mail}>
					{selectedUser &&
					Object.keys(selectedUser).length > 0 && (
						<EmailContent
							selectedUser={selectedUser}
							handleNext={handleNextEmail}
							handlePrev={handlePrevEmail}
							setdeleteMailModal={setdeleteMailModal}
							sendReply={sendReply}
							setSendReply={setSendReply}
						/>
					)}
					<div ref={emailEndRef} />
				</div>
			</div>

			<ComposeMailModal
				composeMailModal={composeMailModal}
				emails={emails}
				setEmails={setEmails}
				handleComposeMailModalClose={() => setComposeMailModal(false)}
				handleComposeMail={() => {}}
			/>

			<DeleteMailModal
				deleteMailModal={deleteMailModal}
				handleDeleteMail={() => {}}
				handleDeleteMailModalClose={() => setdeleteMailModal({ data: {}, status: false })}
			/>
		</Content>
	);
};

export default EmailClient;
